import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { PopUpCodes } from "../../../../../../common/enum/PopUpCodes";
import { fetchActuationGroupRemaining } from "../../../../../../redux/actions/catalog/catalog";
import { useAppSelector } from "../../../../../../redux/hooks";
import { PopUpForm } from "../../../../../common/popup/popUpForm/popUpForm";
import { validateDefaultForm } from "../../../utils/utils";
import { MasterActuationGroupForm } from "./form/form";
import { clearMasterPopUp } from "../../../../../../redux/reducers/resources/master/master";
import { resetMasterActuationGroupForm } from "../../../../../../redux/reducers/resources/master/actuationGroup/form";
import { postAndPutMasterActuationgroup } from "../../../../../../redux/actions/resources/master/actuationGroup/actuationGroup";
import { RequiredFieldsMessage } from "../../../../../common/requiredMessage/requiredMessage";

interface IMasterActuationGroupControllerProps {
    widthPopUp: any;
    heigthPopUp: any;
}

export const MasterBlockMasterController: React.FC<IMasterActuationGroupControllerProps> = ({ widthPopUp, heigthPopUp }) => {
    const { t } = useTranslation("common", { keyPrefix: "MASTERS" });
    const dispatch = useDispatch();

    const { showPopUp } = useAppSelector((state) => state.masterPopUp);
    const { loading, form } = useAppSelector((state) => state.masterActuationGroupForm);
    const { data } = useAppSelector((state) => state.catalog.actuationGroupReamining);

    const onAcceptPopUp = () => {
        dispatch(postAndPutMasterActuationgroup()).then((response: any) => {
            if (response) {
                onCancelPopUp();
            }
        });
    };

    const onCancelPopUp = () => {
        dispatch(clearMasterPopUp());
    };

    const onDimissed = () => {
        dispatch(resetMasterActuationGroupForm());
    };

    const titlePopUp = useMemo(() => {
        if (showPopUp === PopUpCodes.CREATE) {
            return t("CREATE") + " " + t("BUTTON.ACTUATION_GROUP");
        } else if (showPopUp === PopUpCodes.UPDATE) {
            return t("UPDATE") + " " + t("BUTTON.ACTUATION_GROUP");
        }

        return "";
    }, [showPopUp]);

    const isDisabledButton = useMemo(() => {
        return validateDefaultForm(form, showPopUp === PopUpCodes.CREATE);
    }, [form, showPopUp]);

    const showNotData = useMemo(() => {
        return showPopUp === PopUpCodes.CREATE && !data.length;
    }, [data, showPopUp]);

    useEffect(() => {
        showPopUp === PopUpCodes.CREATE && dispatch(fetchActuationGroupRemaining());
    }, [showPopUp]);

    return (
        <PopUpForm
            content={
                <MasterActuationGroupForm
                    showNotData={showNotData}
                    selectorData={data}
                />
            }
            title={titlePopUp}
            isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE}
            onCancel={onCancelPopUp}
            onSave={onAcceptPopUp}
            height={heigthPopUp}
            onDimissed={onDimissed}
            width={widthPopUp}
            isLoading={loading}
            isDisabledButton={isDisabledButton}
            onlyHidden={showNotData}
            leftButtonContent={<RequiredFieldsMessage />}
        />
    );
};
